import { CardComponentProps } from "@~/types/types";
import { QuickViewIcon } from "@~/product-card-components/QuickView/components/QuickViewIcon.tsx";
import { QuickViewButton } from "@~/product-card-components/QuickView/components/QuickViewButton.tsx";
import { isEligibleForQuickView } from "../../utils/product.ts";
import { dispatchAdTechAnalyticsEvent } from "@~/utils/analytics";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent.ts";

export function QuickView({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  if (!isEligibleForQuickView(product)) {
    return null;
  }

  const displayOption: "button" | "icon" =
    configProps?.display === "button" ? "button" : "icon";

  const { associatedAdvertId, clickUrl, impressionUrl } =
    product?.advertising || {};

  const handleQuickViewClick = () => {
    if (associatedAdvertId) {
      dispatchAdTechAnalyticsEvent({
        productId: product.aliases.pimProductId,
        associatedAdvertId,
        clickUrl,
        impressionUrl,
      });
    }
    if (typeof window?.performance?.mark === "function") {
      performance.mark("quickViewDisplayed-start");
    }
  };

  return (
    <div
      data-component="pcl-QuickView"
      onClick={() => {
        sendMonetateEvent("productCard.quickViewIcon.interaction");
      }}
    >
      {displayOption === "icon" ? (
        <QuickViewIcon
          product={product}
          handleIconClick={handleQuickViewClick}
        />
      ) : (
        <QuickViewButton
          product={product}
          handleButtonClick={handleQuickViewClick}
        />
      )}
    </div>
  );
}
